import { useEffect, useState } from "react";
import "../KebabAdd.css"
import { useNavigate } from "react-router-dom";
import PlacesAutocomplete from "./PlacesAutocomplete";
import config from "../config";
import { Rating } from "react-simple-star-rating";

function KebabAdd({ onAdded }) {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [text, setText] = useState("");
    const [formattedAddress, setFormattedAddress] = useState("");
    const [place, setplace] = useState({})
    const [cleanliness, setCleanliness] = useState(5);
    const [atmosphere, setAtmosphere] = useState(5);
    const [taste, setTaste] = useState(5);
    const [service, setService] = useState(5);
    const [code, setCode] = useState("");
    const [images, setImages] = useState([]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("title", title);
        formData.append("text", text);
        formData.append("address", place.address);
        formData.append("cleanliness", cleanliness);
        formData.append("atmosphere", atmosphere);
        formData.append("taste", taste);
        formData.append("service", service);
        formData.append("code", code)
        formData.append("lat", place.lat)
        formData.append("lng", place.lon)

        if (images)
            images.forEach((file) => {
                formData.append("images", file); // "images" = Feldname im Backend
            });
        try {
            const res = await fetch(`${config.BaseUrl}/reviews`, {
                method: "POST",
                body: formData,
            });
            if (res.status === 403) {
                throw new Error("Du bist kein Döner Bro")
            }

            if (!res.ok) throw new Error("Fehler beim Speichern");

            const data = await res.json();
            console.log("Review gespeichert:", data);
            navigate("/")
            // nach dem Speichern alles zurücksetzen
            setTitle("");
            setText("");
            setFormattedAddress("");
            setCode("");
            setCleanliness(0);
            setImages([]);
            alert("Review erfolgreich gespeichert!");
        } catch (err) {
            console.error(err);
            alert(err);
        }
    };

    return (
        <div className="form-container">
            <h2>Neue Review hinzufügen</h2>
            <form onSubmit={handleSubmit} className="review-form">
                <input
                    type="text"
                    placeholder="Titel"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                <textarea
                    placeholder="Dein Text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    required
                />

                <PlacesAutocomplete
                    value={formattedAddress}
                    onSelect={(place) => setplace(place)}
                />
                <div className="inputBox">
                    <label>Sauberkeit</label>
                    <Rating
                        onClick={(rating) => setCleanliness(rating)}
                        allowFraction
                    />
                </div>
                <div className="inputBox">
                    <label>Atmosphäre</label>
                    <Rating
                        onClick={(rating) => setAtmosphere(rating)}
                        allowFraction
                    />
                </div>

                <div className="inputBox">
                    <label>Geschmack</label>
                    <Rating
                        onClick={(rating) => setTaste(rating)}
                        allowFraction
                    />
                </div>

                <div className="inputBox">
                    <label>Service</label>
                    <Rating
                        onClick={(rating) => setService(rating)}
                        allowFraction
                    />
                </div>




                <input
                    type="file"
                    multiple
                    onChange={(e) => setImages(Array.from(e.target.files))}
                />
                <input
                    type="password"
                    placeholder="geheimer Code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />



                <button type="submit">Speichern</button>
            </form>
        </div>
    );
}

export default KebabAdd;